var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notifications',{attrs:{"position":"top center","group":"notifs"}})
}
var staticRenderFns = []

export { render, staticRenderFns }